angular.module('jv.requisition.activities.controller', [])
.controller('ReqsActivitiesCtrl', ['$scope', 'Reqs',
function ($scope, Reqs) {
    $scope.flags.loading = true;
    $scope.activities = {};
    $scope.activities.list = [];
    $scope.activities.count = 0;
    $scope.activities.limit = 20;
    $scope.activities.pageIndex = 0;
    $scope.activities.currentPageIndex = 0;
    $scope.activities.displayHeight = 800;
    $scope.$parent.activityModalShow = false;

    // Private variable
    var options;

    //$scope.flags.loading = true;
    //console.log($scope);

    $scope.showQuickReq = function (id) {
        Reqs.quickView(id, function (response) {
            $scope.$parent.activityModalShow = true;
            $scope.$parent.quickView = response.jobDetails;
            $scope.$parent.quickView = $scope.$parent.quickView || {};
            $scope.$parent.quickView.hasJobAccess = response.hasJobAccess;
            $scope.$parent.postOptions = response.postOptions;
            $scope.$parent.quickView.show = 'requisitions';
        });
    };

    $scope.doAction = function (eid, actionType) {
        if (actionType === 'Copied.Requisition.QuickView') {
            $scope.showQuickReq(eid);
        }
    };

    $scope.$parent.closeQuickView = function () {
        $scope.$parent.quickView.show = false;
    };

    $scope.getActivityFeed = function (start) {
        Reqs.getReqActivity($scope.params.id, 20, start, function (res) {
            if (res.feedContent && res.feedContent.resultList) {
                for (var i = 0; i < res.feedContent.resultList.length; i++) {
                    var activityObj = res.feedContent.resultList[i];
                    $scope.createMsg(activityObj);
                    $scope.createAction(activityObj);
                }

                if (start === 0) {
                    $scope.activities.list = res.feedContent.resultList;
                } else {
                    $scope.activities.list = $scope.activities.list.concat(res.feedContent.resultList);
                }
                $scope.activities.count = res.feedContent.resultCount;
            }
            $scope.flags.loading = false;
        });
    };

    if ($scope.$parent.tabClicked === 'activities') { // On click of tab
        $scope.getActivityFeed(0);
    } else if ($scope.activeTab('#/activities')) { // On pagination or On Refresh
        options = angular.extend({
            paginated: $scope.flags.paginated
        }, $scope.params);
        Reqs.details(options, function (requisition) {
            angular.extend($scope.requisitions, requisition);
            if ($scope.requisitions.forumBaseUrl) {
                $scope.$root.forumBaseUrl = $scope.requisitions.forumBaseUrl;
            }
            $scope.params.id = $scope.requisitions.jobDetails.EId;
            //Fetch the notes count only if the notes tab is visible
            if ($scope.requisitions.views.notesTab) {
                Reqs.getNotesCount($scope.params.id, function (response) {
                    $scope.$parent.requisitions.notesCount = response.notesCount;
                });
            }
            $scope.getActivityFeed(0);
        });
    }

    $scope.createMsg = function (activityObj) {
        activityObj.msg = i18n[activityObj.message];
        for (var j = 0; j < activityObj.customProperties.length; j++) {
            var temp = {};
            temp[activityObj.customProperties[j].name.trim()] = activityObj.customProperties[j].value ? activityObj.customProperties[j].value.trim() : '';
            activityObj.msg = $scope.format(activityObj.msg, temp);
            activityObj.msg = activityObj.msg.replace(/\(\)+/g, '');
        }
    };

    $scope.createAction = function (activityObj) {
        activityObj.doAction = [];
        if (activityObj.actions) {
            for (var j = 0, k = 0; j < activityObj.actions.length; j = j + 3, k++) {
                activityObj.doAction[k] = {};
                activityObj.doAction[k]['type'] = activityObj.actions[j].value || '';
                activityObj.doAction[k]['name'] = activityObj.actions[j + 1].value || '';
                activityObj.doAction[k]['value'] = activityObj.actions[j + 2].value || '';
            }
        }
    };

    $scope.nextFeeds = function () {
        if ($scope.activities.pageIndex === $scope.activities.currentPageIndex) {
            $scope.activities.currentPageIndex++;
            $scope.getActivityFeed($scope.activities.list.length);
        }
        $scope.activities.pageIndex++;
    };

    $scope.hasNext = function () {
        if (($scope.activities.currentPageIndex + 1) * $scope.activities.limit > $scope.activities.count) {
            return false;
        }
        return true;
    };
    }
]);